import React, { useEffect, useState } from "react";
import "./dropdown.scss";
import DropdownArrow from "../../assets/down-arrow.png";

export type dropdownItem = {
  label: string;
  callback: () => void;
};

type DropdownProps = {
  options: dropdownItem[];
  closedText?: string;
  closedIcon?: any;
  initiallySelected?: number;
};
const Dropdown: React.FC<DropdownProps> = ({
  options,
  closedText,
  closedIcon,
  initiallySelected,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<dropdownItem>();

  useEffect(() => {
    if (initiallySelected != null) {
      setSelectedItem(options[initiallySelected]);
    }
  }, [initiallySelected, options]);

  const onItemSelected = (item: dropdownItem) => {
    setSelectedItem(item);
    item.callback();
  };

  return (
    <div
      tabIndex={0}
      onClick={() => setOpen(!open)}
      className="dropdown-wrapper"
    >
      <div className={"header"}>
        <div className={"header-text"}>
          {selectedItem ? (
            selectedItem.label
          ) : closedText ? (
            closedText
          ) : (
            <img
              alt="close-icon"
              src={closedIcon}
              className={"closed-icon"}
            ></img>
          )}
        </div>
        <img
          alt="dropdown-icon"
          src={DropdownArrow}
          className={"dropdown-arrow" + (open ? " open" : "")}
        />
      </div>
      {open && (
        <div className={"dropdown-options"}>
          {options.map((option) => (
            <div
              onClick={() => onItemSelected(option)}
              className={
                "option-item" +
                (selectedItem?.label === option.label ? " selected" : "")
              }
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Dropdown;
